import { RacemapColors } from '@racemap/utilities/consts/common';
import type { Immutable } from 'immer';
import type { TableCellProps } from 'react-virtualized';
import { isShippable } from '../../../../lib/isShippable';
import type { ManagedTracker, ShippingInfo } from '../../../../store/trackers/trackers_reducers';
import { Columns } from '../../../DataTable';
import { IconArrowDoubleRight, IconFailCircle } from '../../../Icon';

interface CellProps extends TableCellProps {
  cellData?: Immutable<ManagedTracker['state']>;
  rowData: Immutable<ManagedTracker>;
}

export const ShippingColumn = ({ shippingInfo }: { shippingInfo: Immutable<ShippingInfo> }) => {
  const cellRenderer = ({ rowData }: CellProps) => {
    if (isShippable(rowData, shippingInfo)) {
      return <IconArrowDoubleRight color={RacemapColors.DarkGreen} />;
    }
    return <IconFailCircle color={RacemapColors.BaseRed} />;
  };

  return Columns.sortingColumn({
    dataKey: 'shipping',
    label: 'Ship',
    cellRenderer,
    width: 100,
    minWidth: 100,
    sortingMethod: (_cA, _cB, rowDataA: ManagedTracker, rowDataB: ManagedTracker) => {
      if (isShippable(rowDataA, shippingInfo) === isShippable(rowDataB, shippingInfo)) {
        return 0;
      }
      return isShippable(rowDataA, shippingInfo) ? -1 : 1;
    },
  });
};
